export default __webpack_public_path__ + "static/media/3.201a764f.jpg";